<form class="cf" [formGroup]="form" (ngSubmit)="submit()" novalidate>

  <!-- Rows layout (createEventRows on): the minimal form, only what a
       right-now event needs. Name, Celebrating chips (picked from the name
       when it says), then Starts / Runs for as rows that open bottom sheets.
       Hosted by and the cover are filled in for the host and stay editable
       later. BUILD_PLAN_INVITE_AB_AND_CREATE_2026-11-03.md, Part 1. -->
  <ng-container *ngIf="rows; else classicFields">

    <!-- "Plan it with me": the conversation's way in. Its panel docks at the
         bottom of the form (end of this template) once it starts. -->
    <button *ngIf="chatEnabled && !chatActive" type="button" class="cf-chat-tile" (click)="startChat()">
      <span class="cf-chat-tile-text">
        <span class="cf-chat-tile-title">Plan it with me</span>
        <span class="cf-chat-tile-sub">I'll ask, you answer. Out loud, or with a tap.</span>
      </span>
      <span class="cf-chat-tile-mic" aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24">
          <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
            <path d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V8Z" />
            <path d="M13.5 8L17 8" /><path d="M13.5 11L17 11" /><path d="M7 8L9 8" /><path d="M7 11L9 11" />
            <path d="M20 10V11C20 15.4183 16.4183 19 12 19C7.58172 19 4 15.4183 4 11V10" />
            <path d="M12 19V22" />
          </g>
        </svg>
      </span>
      <span class="cf-chat-tile-wave" aria-hidden="true"><i *ngFor="let h of chatWave" [style.height.%]="h"></i></span>
    </button>

    <app-voice-panel *ngIf="voice && !chatEnabled"
      [surface]="surface"
      [maxSeconds]="voiceMaxSeconds"
      [categories]="knownCategories"
      [notes]="voiceNotes"
      [partialMessage]="voicePartial"
      [collapsed]="voiceCollapsed"
      (engaged)="loadYourCategories()"
      (parsed)="onVoiceParsed($event)"
      (undo)="onVoiceUndo()">
    </app-voice-panel>

    <div class="cf-field" data-chat="name">
      <label class="cf-label" for="cfEventName">
        Event name
        <ng-container *ngIf="isVoiceFilled('eventName')"><ng-container *ngTemplateOutlet="voiceMark"></ng-container></ng-container>
      </label>
      <input id="cfEventName" class="cf-input" type="text" formControlName="eventName"
        [class.is-asking]="isChatAsking('name')" [class.is-just-filled]="justFilled.has('name')"
        [placeholder]="namePlaceholder" maxlength="200" />
      <p class="cf-error" *ngIf="form.get('eventName')?.touched && form.get('eventName')?.invalid">
        Give your event a name.
      </p>
    </div>

    <!-- The four most-used categories as chips, wrapping (never a sideways
         scroll), plus Other for the sheet's search and add-your-own. A category
         the four don't cover takes Other's place, ticked, so it stays visible. -->
    <div class="cf-field" data-chat="category">
      <span class="cf-label" id="cfCelebrating">
        Celebrating
        <span class="cf-auto" *ngIf="categoryFromName && form.value.eventCategory">· picked from the name</span>
        <ng-container *ngIf="isVoiceFilled('eventCategory')"><ng-container *ngTemplateOutlet="voiceMark"></ng-container></ng-container>
      </span>
      <div class="cf-pills" role="group" aria-labelledby="cfCelebrating"
        [class.is-asking]="isChatAsking('category')" [class.is-just-filled]="justFilled.has('category')">
        <button *ngFor="let chip of chipCategories" type="button" class="cf-pill"
          [class.is-selected]="isChipSelected(chip)" [attr.aria-pressed]="isChipSelected(chip)"
          (click)="selectChip(chip)">
          {{ chip }}
        </button>
        <button type="button" class="cf-pill" aria-haspopup="dialog"
          [class.is-selected]="otherChipSelected" [attr.aria-pressed]="otherChipSelected"
          (click)="openSheetFor('category')">
          {{ otherChipLabel }}
        </button>
      </div>
      <p class="cf-error" *ngIf="categoryInvalid">Pick or name a category.</p>
    </div>

    <div class="cf-field">
      <div class="cf-rows">
        <button type="button" class="cf-rowbtn" aria-haspopup="dialog" (click)="openSheetFor('start')" data-chat="start"
          [class.is-asking]="isChatAsking('start')" [class.is-just-filled]="justFilled.has('start')">
          <span class="cf-rowbtn-label">Starts
            <ng-container *ngIf="isVoiceFilled('start')"><ng-container *ngTemplateOutlet="voiceMark"></ng-container></ng-container>
          </span>
          <span class="cf-rowbtn-value">
            {{ startSummary }}
          </span>
          <ng-container *ngTemplateOutlet="chevron"></ng-container>
        </button>
        <button type="button" class="cf-rowbtn" aria-haspopup="dialog" (click)="openSheetFor('duration')" data-chat="duration"
          [class.is-asking]="isChatAsking('duration')" [class.is-just-filled]="justFilled.has('duration')">
          <span class="cf-rowbtn-label">Runs for
            <ng-container *ngIf="isVoiceFilled('duration')"><ng-container *ngTemplateOutlet="voiceMark"></ng-container></ng-container>
          </span>
          <span class="cf-rowbtn-value">
            {{ runsForSummary }}
          </span>
          <ng-container *ngTemplateOutlet="chevron"></ng-container>
        </button>
      </div>
      <p class="cf-error" *ngIf="form.hasError('endBeforeStart')">The end has to come after the start.</p>
      <p class="cf-error" *ngIf="form.hasError('durationTooLong')">An event can run for at most 10 days.</p>
      <!-- No Hosted by or Cover on this layout: create() sends the account's
           own name (Firebase's displayName is empty for a phone sign-in) and
           a stock cover that suits the category. -->
      <p class="cf-note">We'll add a cover photo for you. Change it, or who's hosting, anytime.</p>
    </div>
  </ng-container>

  <!-- Classic layout (createEventRows off): today's chip form, unchanged. -->
  <ng-template #classicFields>
    <div class="cf-field">
      <label class="cf-label">What are you celebrating?</label>
      <div class="cf-pills" role="group" aria-label="Event category">
        <button *ngFor="let pill of allPills" type="button" class="cf-pill"
          [class.is-selected]="isPillSelected(pill)" [attr.aria-pressed]="isPillSelected(pill)"
          (click)="selectPill(pill)">
          {{ pill }}
        </button>
      </div>
      <input *ngIf="showCustomCategory" class="cf-input cf-input--custom" type="text"
        formControlName="eventCategory" placeholder="Anniversary, reunion, launch party…" maxlength="50"
        aria-label="Category name" />
      <p class="cf-error" *ngIf="form.get('eventCategory')?.touched && form.get('eventCategory')?.invalid">
        Pick or name a category.
      </p>
    </div>

    <div class="cf-field">
      <label class="cf-label" for="cfEventName">Event name</label>
      <input id="cfEventName" class="cf-input" type="text" formControlName="eventName"
        placeholder="Alice &amp; Steve's Wedding" maxlength="200" />
      <p class="cf-error" *ngIf="form.get('eventName')?.touched && form.get('eventName')?.invalid">
        Give your event a name.
      </p>
    </div>

    <div class="cf-field">
      <label class="cf-label" for="cfHostedBy">Hosted by <span class="cf-optional">optional</span></label>
      <input id="cfHostedBy" class="cf-input" type="text" formControlName="hostedBy"
        placeholder="Your name" maxlength="50" />
    </div>

    <div class="cf-field">
      <label class="cf-label" for="cfStartDate">When does it start?</label>
      <div class="cf-row">
        <input id="cfStartDate" class="cf-input" type="date" formControlName="startDate" />
        <select class="cf-input cf-select" formControlName="startTime" aria-label="Start time">
          <option *ngFor="let slot of timeOptions" [value]="slot">{{ slot }}</option>
        </select>
      </div>
      <p class="cf-hint">Starts now by default — change it if the event is later.</p>
    </div>

    <div class="cf-field">
      <label class="cf-label">How long does it run?</label>
      <div class="cf-pills" role="group" aria-label="Duration">
        <button *ngFor="let d of durations" type="button" class="cf-pill"
          [class.is-selected]="durationHours === d.hours && !showCustomEnd"
          [attr.aria-pressed]="durationHours === d.hours && !showCustomEnd"
          (click)="selectDuration(d.hours)">
          {{ d.label }}
        </button>
        <button type="button" class="cf-pill" [class.is-selected]="showCustomEnd"
          [attr.aria-pressed]="showCustomEnd" (click)="selectCustomDuration()">
          Custom
        </button>
      </div>

      <div class="cf-row cf-row--spaced" *ngIf="showCustomEnd">
        <input class="cf-input" type="date" formControlName="endDate" aria-label="End date" />
        <select class="cf-input cf-select" formControlName="endTime" aria-label="End time">
          <option *ngFor="let slot of timeOptions" [value]="slot">{{ slot }}</option>
        </select>
      </div>

      <p class="cf-hint" *ngIf="!showCustomEnd && endSummary">Ends {{ endSummary }}</p>
      <p class="cf-error" *ngIf="form.hasError('endBeforeStart')">The end has to come after the start.</p>
      <p class="cf-error" *ngIf="form.hasError('durationTooLong')">An event can run for at most 10 days.</p>
    </div>
  </ng-template>

  <!-- Classic layout only; the rows layout leaves the cover to Edit details. -->
  <div class="cf-field" data-chat="cover" *ngIf="!rows">
    <label class="cf-label">Cover photo <span class="cf-optional">optional</span></label>
    <div class="cf-cover" *ngIf="coverImage; else pickCover"
      [class.is-asking]="isChatAsking('cover')" [class.is-just-filled]="justFilled.has('cover')">
      <img [src]="coverImage" alt="Event cover" />
      <div class="cf-cover-actions">
        <button type="button" class="cf-cover-btn" (click)="openCoverPicker()">Change</button>
        <button type="button" class="cf-cover-btn" (click)="removeCover()">Remove</button>
      </div>
    </div>
    <ng-template #pickCover>
      <button type="button" class="cf-cover-pick" (click)="openCoverPicker()" [class.is-asking]="isChatAsking('cover')">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
          <rect x="3" y="5" width="18" height="14" rx="3" />
          <circle cx="9" cy="10" r="1.6" />
          <path d="M4 17l5-5 4 4 3-3 4 4" stroke-linejoin="round" />
        </svg>
        Add a cover photo
      </button>
    </ng-template>
  </div>

  <!-- At the end of the form, not pinned: the host passes every field on the
       way to Create, including the start time. Errors sit with the button. -->
  <div class="cf-actions">
    <div class="cf-alert" *ngIf="errorMessage" role="alert">
      <p class="cf-alert-title">{{ errorMessage }}</p>
      <button *ngIf="liveEventConflict" type="button" class="cf-alert-cta" (click)="goToExistingEvents()">Go to your events</button>
    </div>
    <button *ngIf="liveEventConflict && allowSwitchAccount" type="button" class="cf-alert-link"
      (click)="useAnotherAccount()">Use a different account instead</button>

    <!-- "You already have this event" (recent-creates.ts): takes Create's place,
         so the choice is between these two and nothing is red while it's open.
         Outside the !chatActive block: the conversation's Create lands here too. -->
    <div class="cf-dup" *ngIf="duplicateOf" role="alertdialog" aria-labelledby="cfDupTitle" aria-describedby="cfDupBody">
      <p class="cf-dup-title" id="cfDupTitle">
        You already have “{{ duplicateOf.name }}”<ng-container *ngIf="duplicateDate"> on {{ duplicateDate }}</ng-container>
      </p>
      <p class="cf-dup-body" id="cfDupBody">
        You made it {{ duplicateAgo }}. A second event splits your guests and photos between the two, so change that one instead.
      </p>
      <button type="button" class="cf-dup-main" (click)="editDuplicateInstead()">Edit it instead</button>
      <button type="button" class="cf-dup-sec" (click)="createDuplicateAnyway()">Create a new one</button>
    </div>

    <!-- The one red on the form: creating the album is on the design system's hero list.
         While the conversation runs, Create lives in its panel instead. -->
    <ng-container *ngIf="!chatActive && !duplicateOf">
      <button type="submit" class="cf-cta" [disabled]="isWorking">
        {{ isWorking ? 'Creating…' : 'Create event' }}
      </button>
      <p class="cf-footnote" *ngIf="footnote">{{ footnote }}</p>
    </ng-container>
  </div>

  <!-- "Plan it with me": sticks to the bottom while it runs; nothing shows until then. -->
  <app-voice-chat *ngIf="chatEnabled" [host]="this" [surface]="surface"></app-voice-chat>
</form>

<!-- Rows layout's pickers. Rendered through a CDK overlay (above the create
     sheet), so where they sit in this template doesn't matter. -->
<ng-container *ngIf="rows">
  <app-picker-sheet [open]="openSheet === 'category'" title="What are you celebrating?" (closed)="closeSheet()">
    <app-category-sheet *ngIf="openSheet === 'category'"
      [value]="form.value.eventCategory || ''"
      [yours]="yourCategories"
      (picked)="onCategoryPicked($event)">
    </app-category-sheet>
  </app-picker-sheet>

  <app-picker-sheet [open]="openSheet === 'start'" title="When does it start?" actionLabel="Done"
    (closed)="closeSheet()" (action)="onStartDone()">
    <app-start-sheet *ngIf="openSheet === 'start'"
      [date]="form.value.startDate || ''"
      [time]="form.value.startTime || ''"
      [timeOptions]="timeOptions"
      (picked)="onStartPicked($event)">
    </app-start-sheet>
  </app-picker-sheet>

  <app-picker-sheet [open]="openSheet === 'duration'" title="How long does it run?"
    [actionLabel]="durationCustomOpen ? 'Done' : ''"
    (closed)="closeSheet()" (action)="onDurationDone()">
    <app-duration-sheet *ngIf="openSheet === 'duration'"
      [startDate]="form.value.startDate || ''"
      [startTime]="form.value.startTime || ''"
      [durationHours]="durationHours"
      [endDate]="form.value.endDate || ''"
      [endTime]="form.value.endTime || ''"
      [presets]="durations"
      [timeOptions]="timeOptions"
      (pickedPreset)="onDurationPreset($event)"
      (pickedCustom)="onDurationCustom($event)"
      (customOpenChange)="durationCustomOpen = $event">
    </app-duration-sheet>
  </app-picker-sheet>
</ng-container>

<!-- Solar alt-arrow-right-linear, 20 in text-2 (§6 list row). -->
<ng-template #chevron>
  <svg class="cf-rowbtn-chevron" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 5L15 12L9 19" />
  </svg>
</ng-template>

<!-- Marks a field voice filled in (plan §7.4). Solar microphone-2-linear, 16 in text-2. -->
<ng-template #voiceMark>
  <svg class="cf-voice-mark" width="16" height="16" viewBox="0 0 24 24" role="img" aria-label="Filled in from what you said">
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
      <path d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V8Z" />
      <path d="M13.5 8L17 8" /><path d="M13.5 11L17 11" /><path d="M7 8L9 8" /><path d="M7 11L9 11" />
      <path d="M20 10V11C20 15.4183 16.4183 19 12 19C7.58172 19 4 15.4183 4 11V10" />
      <path d="M12 19V22" />
    </g>
  </svg>
</ng-template>
